import React, { useState } from "react";
import HeaderPost from "../blog/HeaderPost";
import AccompagnementClotere from '../components/AccompagnementClotere'
import PrendreRdv from "../leadPage/prendreRdv";
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'
import { CurrencyEuroIcon } from "@heroicons/react/16/solid";
import AddressInput from "../components/AdresseInput";



function CalculFraisNotaire(args) {
    const [purchasePrice, setPurchasePrice] = useState(250000);
    const [projectType, setProjectType] = useState("ancien");
    const [results, setResults] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);


    const calculateFees = () => {
        if (!purchasePrice || isNaN(purchasePrice)) return;

        const totalFees =
            projectType === "ancien"
                ? purchasePrice * 0.08 // 8% pour un bien ancien
                : purchasePrice * 0.03; // 3% pour un bien neuf

        // Répartition des frais
        const taxes = totalFees * 0.757;
        const emoluments = totalFees * 0.156;
        const debours = totalFees * 0.087;

        setResults({
            total: totalFees.toFixed(2),
            impots: taxes.toFixed(2), // important pour l’affichage, ta clé est "impots"
            emoluments: emoluments.toFixed(2),
            debours: debours.toFixed(2),
        });
    };

    return (
        <>
            <HeaderPost titre="Calculateur frais de notaire - Achat immobilier" breadlink1="/outils/notaire" namelink1="Outils" namelinkActive="Calculateur frais de notaire" />

            {/** calculateur */}
            <section className="">
                <div className="container">
                    <div className="flex flex-col sm:flex-row gap-16 items-center flex-wrap">
                        {/** form  */}
                        <div className="flex-1 w-full">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div>
                                    <label className="block font-medium mb-2">Prix d'achat (€)</label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            value={purchasePrice.toLocaleString("fr-FR")}
                                            onChange={(e) => {
                                                const cleaned = e.target.value.replace(/\s/g, "").replace(/[^0-9]/g, "");
                                                setPurchasePrice(Number(cleaned));
                                            }}
                                            className="input-clotere w-full py-2 px-4 rounded-md border border-gray-300"
                                            placeholder="Ex : 250 000"
                                        />
                                        <CurrencyEuroIcon className="absolute right-3 top-2.5 h-5 w-5 text-gray-400" />
                                    </div>
                                </div>

                                <div>
                                    <label className="block font-medium mb-2">Type de projet</label>
                                    <select
                                        value={projectType}
                                        onChange={(e) => setProjectType(e.target.value)}
                                        className="input-clotere w-full py-2 px-4 rounded-md border border-gray-300"
                                    >
                                        <option value="ancien">Achat ancien</option>
                                        <option value="neuf">Achat neuf</option>
                                    </select>
                                </div>

                                <div className="sm:col-span-2">
                                    <label className="block font-medium mb-2">Ville (Code postal ou nom)</label>
                                    <AddressInput className="input-clotere" onAddressSelect={(place) => setSelectedAddress(place)} />

                                </div>

                                <div className="sm:col-span-2">
                                    <button
                                        onClick={calculateFees}
                                        className="w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700"
                                    >
                                        Calculer les frais de notaire
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/** result */}
                        <div className="flex-1 w-full">
                            <div className="p-4 bg-gray-50 rounded-lg text-sm text-gray-700">
                                <div className="bg-slate-100 p-12 rounded-lg text-center">
                                    <p className="font-medium mb-2">Estimation de vos frais de notaire </p>
                                    <p className="font-bold text-5xl text-indigo-800">{results ? `${results.total} €` : "-- €"} </p>
                                </div>

                                <div className="border-t border-gray-300">
                                    <dl className="divide-y divide-gray-300">
                                        <div className="p-3 sm:grid sm:grid-cols-2 items-center">
                                            <dt className="text-sm font-medium text-gray-700 items-center flex"><span className="text-indigo-600 text-3xl">•</span> Taxes et impôts</dt>
                                            <dd className="mt-1 text-xl font-bold  sm:mt-0">{results ? `${results.impots} €` : "-- €"}</dd>
                                        </div>
                                        <div className="p-3 sm:grid sm:grid-cols-2 items-center">
                                            <dt className="text-sm font-medium text-gray-700 items-center flex"><span className="text-orange-600 text-3xl">•</span> Emoluments du notaire</dt>
                                            <dd className="mt-1 text-xl font-bold  sm:mt-0">{results ? `${results.emoluments} €` : "-- €"} </dd>
                                        </div>
                                        <div className="p-3 sm:grid sm:grid-cols-2 items-center">
                                            <dt className="text-sm font-medium text-gray-700 items-center flex"><span className="text-yellow-600 text-3xl">•</span> Débours</dt>
                                            <dd className="mt-1 text-xl font-bold  sm:mt-0">{results ? `${results.debours} €` : "-- €"}</dd>
                                        </div>
                                    </dl>
                                </div>
                            </div>

                        </div>



                    </div>
                </div>
            </section>

            {/** 3 informations clés */}
            <section className="mt-10">
                <div className="container">
                    <div>
                        <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:space-y-0 sm:gap-y-16 lg:grid-cols-3 lg:gap-x-10">
                            <div className="bg-indigo-800 text-white rounded-md p-4 flex flex-col justify-around">
                                <dt className="text-base/7 font-semibold">De quoi se composent les frais de notaire ?</dt>
                                <dd className="mt-2 text-base/7">
                                    <ul>
                                        <li>• <b>Les droits et taxes</b> : ces sommes sont directement versées à l'État ou aux collectivités territoriales.</li>
                                        <li>• <b>Les débours</b> : Ils couvrent les frais engagés par le notaire pour le traitement et la gestion du dossier.</li>
                                        <li>• <b>Les émoluments ou honoraires</b> : Il s'agit de la rémunération du notaire pour son intervention.</li>
                                    </ul>
                                </dd>
                                <a href="https://clotere.fr/immobilier/notaire/de-quoi-se-compose-les-frais-de-notaire" target="blank" className=" text-white">En savoir plus</a>
                            </div>
                            <div className="bg-indigo-800 text-white rounded-md p-4 flex flex-col justify-around">
                                <dt className="text-base/7 font-semibold">Les frais de notaire sont-ils négociables ?</dt>
                                <dd className="mt-2 text-base/7">
                                    Certains frais de notaire sont négociables. Bien que majoritairement composés de taxes, une partie des frais concerne les émoluments du notaire. Depuis 2016, une remise jusqu’à 20 % peut être accordée sur ces honoraires pour les transactions supérieures à 150 000 €.
                                    <br />
                                    Il existe aussi quelques possibilités pour réduire les frais de notaire.
                                </dd>
                                <a href="https://clotere.framer.website/blog/astuces-pour-r%C3%A9duire-vos-frais-de-notaire-lors-d-un-achat-immobilier" target="blank" className=" text-white">En savoir plus</a>
                            </div>
                            <div className="bg-purple-800 text-white rounded-md p-4 flex flex-col justify-around">
                                <dt className="text-base/7 font-semibold">Bon à savoir</dt>
                                <dd className="mt-2 text-base/7">Clotere.fr vous permet d'anticiper au mieux tous les frais et les étapes liés à votre achat immobilier :
                                    <ul className="p-0">
                                        <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4" /> Estimez vos frais de notaire</li>
                                        <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4" /> Choisissez votre notaire</li>
                                        <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4" /> Déposez vos documents</li>
                                        <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4" /> Fixez simplement votre rendez-vous de signature</li>
                                        <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4" /> Posez toutes vos questions à votre conseiller dédié Clotere</li>
                                    </ul>
                                </dd>
                                <Link to="/onboard/achat" className=" text-white">Trouvez votre notaire gratuitement</Link>
                            </div>
                        </dl>
                    </div>
                </div>
            </section>

            {/** CTA */}
            <div className="">
                <div className="mx-auto max-w-7xl px-6 py-16 lg:flex lg:items-center lg:justify-between lg:px-8 rounded-xl bg-indigo-50 mt-10">
                    <div>
                        <h2 className="max-w-2xl text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                            Vous recherchez un notaire pour votre achat immobilier ?
                        </h2>
                        <p>Clotere, vous met en relation avec des notaires disponibles et <br />vous accompagne de A à Z dans la constitution de votre dossier.</p>
                    </div>
                    <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:shrink-0">
                        <Link
                            to="/onboard/achat"
                            className="no-underline rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Trouver mon notaire immobilier
                        </Link>
                        <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2N3sMiWCWTD3GWAp9oN-FoJEdzm42kuKNeR0ZTFdXc1V4UG5DSezuPQXlFiGHvzrwOZKPcJbjL" target="blank" className="text-sm/6 font-semibold text-gray-900">
                            Prendre rendez-vous <span aria-hidden="true">→</span>
                        </a>
                    </div>
                </div>
            </div>



            {/** section SEO 
            <Container>
                <section class=" mt-4 mb-4 flex flex-row flex-wrap justify-center items-center">

                    <div className="w-full sm:basis-1/2  p-4 ">
                        <img alt="trouvez un notaire pour votre achat immobilier" src={CompositionFrais} className="rounded overflow-hidden" />
                    </div>
                    <div className="w-full sm:basis-1/2  p-4">
                        <h2 className="font-bold">De quoi se composent les <span className="text-[#1df36c]">frais de notaire</span></h2>
                        <p>Les frais de notaire  se divisent en trois grandes catégories&nbsp;:</p>
                        <ul>
                            <li><strong>• Les droits et taxes</strong> : Ces sommes sont directement versées à l'État ou aux collectivités territoriales.</li>
                            <li><strong>• Les débours</strong> : Ils couvrent les frais engagés par le notaire pour le traitement et la gestion du dossier (copies, documents administratifs, etc.).</li>
                            <li><strong>• Les émoluments ou honoraires</strong> : Il s'agit de la rémunération du notaire pour son intervention, notamment la rédaction de l'acte authentique.</li>
                        </ul>
                        <p>Contrairement à une idée reçue, les frais dits «&nbsp;de notaire&nbsp;» ne se limitent pas aux honoraires du professionnel. En réalité, ces derniers ne représentent qu'environ <strong>10 à 15&nbsp;%</strong> du total. La majeure partie des frais correspond aux taxes perçues par l'État et les collectivités locales.</p>
                        <p> Une petite partie de ces frais sont négociables, parlez en avec votre notaire.</p>
                        <Link to="/inscription/achat"
                            type="button"
                            className="no-underline inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-3.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                            Parler avec mon notaire
                            <ArrowRightIcon aria-hidden="true" className="-mr-0.5 size-5" />
                        </Link>
                    </div>

                </section>
            </Container>*/}

            {/** section faq frais de notaire */}
            <div className="container">
                <section className="">
                    <div className="bg-white">
                        <div className="mx-auto max-w-7xl px-6 py-24">
                            <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                                <div className="lg:col-span-5">
                                    <h2 className="text-pretty text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
                                        Questions les plus fréquentes sur les frais de notaire.
                                    </h2>
                                    <p className="mt-4 text-pretty text-base leading-7 text-gray-600">
                                        Vous n'avez pas trouvé de réponse à vos questions ?
                                        Contactez-nous directement {" "}
                                        <a href="mailto:contact@clotere.fr" className="font-semibold text-indigo-600 hover:text-indigo-500">
                                            contact@clotere.fr
                                        </a>{' '}

                                    </p>
                                </div>
                                <div className="mt-10 lg:col-span-7 lg:mt-0">
                                    <dl className="space-y-6 divide-y divide-gray-900/10">
                                        <Disclosure as="div" className="">
                                            <dt>
                                                <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                                                    <span className="text-xl font-semibold">
                                                        A quel moment régler les frais de notaire ?
                                                    </span>
                                                    <span className="ml-6 flex h-7 items-center">
                                                        <PlusSmallIcon aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                                                        <MinusSmallIcon aria-hidden="true" className="size-6 [.group:not([data-open])_&]:hidden" />
                                                    </span>
                                                </DisclosureButton>
                                            </dt>
                                            <DisclosurePanel as="dd" className="mt-2 pr-12">
                                                <p className="text-base leading-7 text-gray-600">
                                                    Les frais de notaire doivent être acquittés lors de la signature définitive de l’acte authentique de vente, généralement environ trois mois après la signature du compromis ou de la promesse de vente.
                                                    <br />
                                                    <b>👋 Attention cependant au séquestre</b>
                                                    <br />
                                                    Lors de la signature du compromis de vente, il est fréquent que l'acheteur verse un dépot de garantie, aussi appelé séquestre. Bien que ce versement ne soit pas obligatoire légalement, il est largement pratiqué. Ce dépôt correspond habituellement à<b> 5 à 10 % du prix total de vente</b>. <br />Si le séquestre a été versé, son montant sera déduit du solde à régler le jour de la signature de l’acte authentique.
                                                    <br />Le notaire, lorsqu’il reçoit ce dépôt, le place en sécurité sur un compte à la Caisse des Dépôts et Consignations.

                                                    En cas de différence entre le dépôt de garantie et le montant total dû, le notaire remboursera l’excédent. Vous recevrez également un récapitulatif détaillé des frais réellement engagés. Ce document, généralement transmis entre deux et six mois après la finalisation de la vente, permettra de comprendre la répartition exacte des frais.
                                                </p>
                                            </DisclosurePanel>
                                        </Disclosure>
                                        <Disclosure as="div" className="">
                                            <dt>
                                                <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900 mt-4">
                                                    <span className="text-xl font-semibold">
                                                        Les frais de notaire sont-ils négociables ?
                                                    </span>
                                                    <span className="ml-6 flex h-7 items-center">
                                                        <PlusSmallIcon aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                                                        <MinusSmallIcon aria-hidden="true" className="size-6 [.group:not([data-open])_&]:hidden" />
                                                    </span>
                                                </DisclosureButton>
                                            </dt>
                                            <DisclosurePanel as="dd" className="mt-2 pr-12">
                                                <p className="text-base leading-7 text-gray-600">
                                                    Bien que réglementés, il existe certaines marges de manœuvre pour réduire la facture.
                                                    <br />
                                                    La majorité des frais de notaire étant des taxes et impôts, une petite partie liée à la rémunération des notaires peut-être négociée.
                                                    <br /><br />
                                                    Depuis 2016, une réforme a introduit une légère flexibilité dans les émoluments du notaire pour les transactions immobilières de plus de 150 000 €. Dans ce cas, le notaire peut accorder une remise exceptionnelle pouvant aller jusqu’à 20 % sur ses honoraires.

                                                </p>
                                            </DisclosurePanel>
                                        </Disclosure>
                                        <Disclosure as="div" className="">
                                            <dt>
                                                <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900 mt-4">
                                                    <span className="text-xl font-semibold">
                                                        Comment payer moins de frais de notaire ?
                                                    </span>
                                                    <span className="ml-6 flex h-7 items-center">
                                                        <PlusSmallIcon aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                                                        <MinusSmallIcon aria-hidden="true" className="size-6 [.group:not([data-open])_&]:hidden" />
                                                    </span>
                                                </DisclosureButton>
                                            </dt>
                                            <DisclosurePanel as="dd" className="mt-2 pr-12">
                                                <p className="text-base leading-7 text-gray-600">
                                                    Une manière supplémentaire de réduire les frais consiste à <b>soustraire le coût du mobilier inclus dans le logement</b>. En effet, les frais de notaire s’appliquent uniquement à la valeur du bien immobilier hors équipements.
                                                    <br /> Ainsi, si le logement dispose d’une salle de bains équipée ou d’une cuisine intégrant des appareils électroménagers, leur valeur peut être déduite du prix total, ce qui permet de diminuer la base de calcul des frais.
                                                </p>
                                            </DisclosurePanel>
                                        </Disclosure>
                                        <Disclosure as="div" className="">
                                            <dt>
                                                <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900 mt-4">
                                                    <span className="text-xl font-semibold">
                                                        Peux-t-on financer les frais de notaire avec un prêt immobilier ?
                                                    </span>
                                                    <span className="ml-6 flex h-7 items-center">
                                                        <PlusSmallIcon aria-hidden="true" className="size-6 group-data-[open]:hidden" />
                                                        <MinusSmallIcon aria-hidden="true" className="size-6 [.group:not([data-open])_&]:hidden" />
                                                    </span>
                                                </DisclosureButton>
                                            </dt>
                                            <DisclosurePanel as="dd" className="mt-2 pr-12">
                                                <p className="text-base leading-7 text-gray-600">
                                                    Lors de l’achat d’un bien immobilier avec un crédit, il est possible d’inclure divers frais dans le montant emprunté, tels que les intérêts, l’assurance emprunteur, les frais de notaire ou encore les frais d’agence immobilière.
                                                    <br /><br />
                                                    Cependant, <b>les banques exigent de plus en plus souvent un apport personnel pour couvrir les frais de notaire et d’agence</b>. Réaliser une simulation avant l’achat permet d’évaluer précisément ces frais, facilitant ainsi la planification de votre projet immobilier et le calcul de l’apport nécessaire pour obtenir votre prêt.
                                                </p>
                                            </DisclosurePanel>
                                        </Disclosure>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/** accompagnement */}
            <AccompagnementClotere />

            <br />
            <PrendreRdv />
            <Footer />

        </>
    );

}

export default CalculFraisNotaire;